import { render } from "./VirtualMachineReserved.vue?vue&type=template&id=73b65640"
import script from "./VirtualMachineReserved.vue?vue&type=script&lang=js"
export * from "./VirtualMachineReserved.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__